<div class="sd-dialog">
    <button type="button" class="sd-icon-btn sd-dialog__close" aria-label="Close" (click)="dismiss()">
        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
        </svg>
    </button>

    <h3 class="sd-dialog__title">{{ title }}</h3>
    <p class="sd-dialog__message">{{ message }}</p>

    <div class="sd-dialog__actions">
        <button type="button" class="sd-btn sd-btn--secondary" (click)="decline()">{{ btnCancelText }}</button>
        <button type="button" class="sd-btn sd-btn--primary" (click)="accept()">{{ btnOkText }}</button>
    </div>
</div>
